export * from './simple-accordion-details';